import { render, staticRenderFns } from "./appComponent.vue?vue&type=template&id=f55c75b0&scoped=true&"
import script from "./appComponent.vue?vue&type=script&lang=js&"
export * from "./appComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55c75b0",
  null
  
)

export default component.exports